import { gql } from 'apollo-boost';

export const UPDATE_CHAT_ACTION = gql`
    mutation UpdateChatAction($data: UpdateChatActionInput!) {
        updateChatAction(data: $data) {
            id
            ownerUserId
            slashCommand
            label
            description
            scope
            visibility
            promptTemplate
            isActive
            isSystem
            createdAt
            updatedAt
        }
    }
`;
